<template lang="pug">
include /mixins
+b.ticket_management-form-result-success
  +e.img-wrap
    +e.img(
      src='/static/img/totik/eye.png'
      alt='success'
    )
  +e.title.P {{ (info && info.title) || _('Спасибо за Ваше обращение!')}}
  +e.text.P {{ (info && info.text) || _('Мы рассмотрим запрос на деактивацию билета в ближайшее время.')}}
  +e.actions
    +b.ticket-management-share(v-if='info.action === FILE_DOWNLOAD_ACTION')
      +e.description--center.P {{ _('Вам доступен файл для скачивания') }}
      +e.btn--center
        +b.tt-button--auto.--bordered_grey-v2.A(
          :href='info.file',
          download
        )
          +e.icon.SVG(width='24' height='24' viewbox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg')
            path(d='M12 10L12 17' stroke='#1183F6')
            path(d='M8 13L12 17L16 13' stroke='#1183F6')
            rect(x='6' y='17' width='1' height='3' fill='#1183F6')
            rect(x='17' y='17' width='1' height='3' fill='#1183F6')
            rect(x='18' y='19' width='1' height='12' transform='rotate(90 18 19)' fill='#1183F6')
            path(d='M5 1.5H12.1719C12.5696 1.50008 12.9512 1.65822 13.2324 1.93945L20.0605 8.76758C20.3418 9.04881 20.4999 9.43041 20.5 9.82812V21C20.5 21.8284 19.8284 22.5 19 22.5H5C4.17157 22.5 3.5 21.8284 3.5 21V3C3.5 2.17157 4.17157 1.5 5 1.5Z' stroke='#1183F6')
          +e.title.SPAN {{ _('Скачать файл') }}
    +b.ticket-management-share(v-if='info.action === REDIRECT_ACTION')
      +e.description--center.P {{ _('Перейдите по ссылке') }}
      +e.btn--center
        +b.tt-button--auto.--bordered_grey-v2.BUTTON(
          @click='open'
        )
          +e.icon.SVG(width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg")
            path(
              d="M4.5 8.5V20.5C4.5 21.0523 4.94772 21.5 5.5 21.5H14.5M18.5 18.5H8.5C7.94772 18.5 7.5 18.0523 7.5 17.5V4.5C7.5 3.94772 7.94772 3.5 8.5 3.5H18.5C19.0523 3.5 19.5 3.94772 19.5 4.5V17.5C19.5 18.0523 19.0523 18.5 18.5 18.5Z"
              stroke="#1183F6" stroke-width="1.5" stroke-linecap="round"
            )

          +e.title.SPAN {{ _('Скопировать ссылку') }}
      template(v-if='info.redirect_show_share')
        +e.text--center.P {{ _('или выберите удобный мессенджер для отправки ссылки') }}
        +e.links--center
          row(appearance='spaced')
            cell(cols v-for='{ network, icon, title }, index in networks' :key='index')
              share-network.share-wrapper(
                :url="info.url"
                :network='network'
                :title="info.title"
              )
                +b.new-social-link-icon.A(
                  :title="title"
                )
                  +e.icon.IMG(:src="`/static/img/social/${icon}_new.svg`")
</template>

<script>

const REDIRECT_ACTION = 'redirect'
const FILE_DOWNLOAD_ACTION = 'download_file'

export default {
  name: 'TicketManagementSuccess',
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    action: {
      type: String,
      default: null,
    },
    file: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    redirect_show_share: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      REDIRECT_ACTION,
      FILE_DOWNLOAD_ACTION,
      networks: [
        { icon: 'telegram', network: 'telegram', title: this._('Telegram') },
        { icon: 'viber', network: 'viber', title: this._('Viber') },
        { icon: 'messenger', network: 'messenger', title: this._('messenger') },
        // { icon: 'letter', network: 'email', title: this._('Email') },
      ],
      show: false,
    }
  },
  methods: {
    async open() {
      const ZERO = 0
      if (
        (navigator.maxTouchPoints > ZERO ||
        navigator.msMaxTouchPoints > ZERO) &&
        navigator.canShare()
      ) {
        await navigator.share({
          title: this.info.title,
          url: this.info.url,
        })
        return
      }
      this.copy()
      this.show = !this.show
    },
    close() {
      this.show = false
    },
    async copy() {
      try {
        await navigator.clipboard.writeText(this.info.url)
        this.$notify({
          type: 'notify',
          title: `${this._('Посилання скопійовано')}`,
        })
      } catch (err) {
        this.$notify({
          type: 'notify',
          title: `${this._('Посилання не вдалося скопіювати')}`,
        })
        throw new Error('Oops, unable to copy')
      }
    },
  },
};
</script>
